/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProgramSettingsRequest
 */
export interface UpdateProgramSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProgramSettingsRequest
     */
    healthCheckCron?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateProgramSettingsRequest
     */
    fiscalYearStartMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateProgramSettingsRequest
     */
    autoArchiveDays?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProgramSettingsRequest
     */
    snapshotOnBoardReport?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateProgramSettingsRequest
     */
    riskThresholds?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProgramSettingsRequest
     */
    drivenByTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateProgramSettingsRequest
     */
    quickBaselineSchemaSlug?: string;
}

/**
 * Check if a given object implements the UpdateProgramSettingsRequest interface.
 */
export function instanceOfUpdateProgramSettingsRequest(value: object): value is UpdateProgramSettingsRequest {
    return true;
}

export function UpdateProgramSettingsRequestFromJSON(json: any): UpdateProgramSettingsRequest {
    return UpdateProgramSettingsRequestFromJSONTyped(json, false);
}

export function UpdateProgramSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProgramSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'healthCheckCron': json['healthCheckCron'] == null ? undefined : json['healthCheckCron'],
        'fiscalYearStartMonth': json['fiscalYearStartMonth'] == null ? undefined : json['fiscalYearStartMonth'],
        'autoArchiveDays': json['autoArchiveDays'] == null ? undefined : json['autoArchiveDays'],
        'snapshotOnBoardReport': json['snapshotOnBoardReport'] == null ? undefined : json['snapshotOnBoardReport'],
        'riskThresholds': json['riskThresholds'] == null ? undefined : json['riskThresholds'],
        'drivenByTags': json['drivenByTags'] == null ? undefined : json['drivenByTags'],
        'quickBaselineSchemaSlug': json['quickBaselineSchemaSlug'] == null ? undefined : json['quickBaselineSchemaSlug'],
    };
}

export function UpdateProgramSettingsRequestToJSON(json: any): UpdateProgramSettingsRequest {
    return UpdateProgramSettingsRequestToJSONTyped(json, false);
}

export function UpdateProgramSettingsRequestToJSONTyped(value?: UpdateProgramSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'healthCheckCron': value['healthCheckCron'],
        'fiscalYearStartMonth': value['fiscalYearStartMonth'],
        'autoArchiveDays': value['autoArchiveDays'],
        'snapshotOnBoardReport': value['snapshotOnBoardReport'],
        'riskThresholds': value['riskThresholds'],
        'drivenByTags': value['drivenByTags'],
        'quickBaselineSchemaSlug': value['quickBaselineSchemaSlug'],
    };
}

